import React from "react";
import Head from "next/head";
// eslint-disable-next-line no-restricted-imports -- TODO: update to `next/navigation` before using this component in App Router
import { useRouter } from "next/router";

import useDomain from "@/hooks/useDomain";
import parseNextRouterAsPath from "@/utils/parseNextRouterAsPath";

import createPaginationUrl from "./createPaginationUrl";

const RelativeLinkTags: React.FC<{
  currentPage: number;
  pageInPath?: boolean;
  totalPages: number;
}> = ({ currentPage, pageInPath, totalPages }) => {
  const { asPath } = useRouter();
  const domain = useDomain();

  const { path, query } = parseNextRouterAsPath(asPath);

  const prevUrl = createPaginationUrl(
    path,
    query,
    pageInPath,
    currentPage > 2 ? currentPage - 1 : undefined,
  );

  const nextUrl = createPaginationUrl(path, query, pageInPath, currentPage + 1);

  return (
    <Head>
      {/* SEO: All pages that can possibly be paginated should have these tags */}
      {currentPage > 1 && <link rel="prev" href={`${domain}${prevUrl}`} />}
      {currentPage < totalPages && (
        <link rel="next" href={`${domain}${nextUrl}`} />
      )}
    </Head>
  );
};

export default RelativeLinkTags;
